import { Ref } from 'react';
import { ShopTypes } from '~/lib/data-contract';
import { useTranslations } from '~/services/umbraco/hooks';
import { AccordionItem, AccordionItemRef } from '~/shared/components/Accordion';
import { Text } from './styled';

const ProductDeliveryAccordion = ({
    product,
    ref,
}: {
    product?: ShopTypes.ProductQueryProduct;
    ref?: Ref<AccordionItemRef>;
}) => {
    const { translate } = useTranslations();

    if (!product?.item?.freightInfo) {
        return null;
    }

    const { item } = product;

    return (
        <AccordionItem ref={ref} id="delivery" header={translate('product.deliveryTitle')}>
            {item?.freightInfo?.freightType ? (
                <Text isTitle>
                    {translate('product.deliveryType')} {item?.freightInfo?.freightName}
                </Text>
            ) : null}

            {item?.freightInfo?.freightDescription ? (
                <Text>
                    {translate('product.deliveryAndShipping')}
                    <br />
                    {item?.freightInfo?.freightDescription}
                </Text>
            ) : null}
        </AccordionItem>
    );
};

export default ProductDeliveryAccordion;
